import { AuthOptions } from '@aws-amplify/auth/lib-esm/types'

const awsConfig: AuthOptions = {
  region: 'ca-central-1',
  userPoolId: 'REPLACE_ME', // Will be fed from `auth.ts`.
  userPoolWebClientId: 'REPLACE_ME', // Will be fed from `auth.ts`.
}

export default awsConfig
